export default {
  LOAD_DATA: "LOAD_DATA",
  CHANGE_NAME:"CHANGE_NAME",
  CHANGE_LANGUAGE_CODE:"CHANGE_LANGUAGE_CODE",
}